import React from 'react';
import ConstructionIcon from '@mui/icons-material/Construction';

// Placeholder for the 18 not-yet-built validation rules (D3).
export default function ComingSoon({ title, description }) {
  return (
    <div className="coming-soon">
      <span className="coming-soon-icon"><ConstructionIcon /></span>
      <h2>{title || 'Coming soon'}</h2>
      <p>
        {description ||
          'This validation rule is planned but not yet available. The screen and data path are wired for a future release.'}
      </p>
    </div>
  );
}
